import React, { useState } from "react";
import { RootState } from "../../../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import useMultiNotification from "../../../hooks/useNotification";
import { Button, Col, Row, Typography } from "antd";
import PhoneIcon from "./../../../graphics/svgs/PhoneIcon.svg";
import MailIcon from "./../../../graphics/svgs/MailIcon.svg";
import AddressIcon from "./../../../graphics/svgs/AddressIcon.svg";
import { userOrderHistoryTableDesktopHeaders } from "../../../helpers/viewUsersConstants";
import TableHeader from "../../Items/Table/Header";
import OrderHistoryTableRow from "./OrderHistoryTableRow";
import OrderHistoryCard from "../../Items/cards/OrderHistoryCard";
import { formatDateInMMDDYYYY } from "../../../helpers/date";
export default function UserProfileTab() {
  const generalState = useSelector((state: RootState) => state.general);
  const { singleUserProfile } = useSelector(
    (state: RootState) => state.dashboard
  );
  const { isShowTableInDesktop } = generalState;
  const { contextHolder, openNotification } = useMultiNotification();
  const [desktopTableHeaders, setDesktopTableHeaders] = useState<
    DesktopTableHeaderOption[]
  >(userOrderHistoryTableDesktopHeaders);
  const handleCheckBox = (checked: boolean, id: string) => {};
  if (!singleUserProfile) {
    return <></>;
  }
  const { userProfile, orderHistory } = singleUserProfile;
  const latesOrder = orderHistory.length > 0 ? orderHistory[0] : null;
  return (
    <>
      {contextHolder}
      <Row className="w-100p">
        <Col
          className="mb-10 mt-10"
          lg={8}
          xl={8}
          xxl={8}
          md={24}
          sm={24}
          xs={24}
        >
          <Typography className="dashboard-page-sub-title">
            {userProfile.firstName} {userProfile.lastName}
          </Typography>
          <div className="display-flex">
            <Typography className="users-table-generic-label">
              <img src={PhoneIcon} /> (914) 815-660
            </Typography>{" "}
            <Typography className="users-table-generic-label">
              <img src={MailIcon} /> {userProfile.email}
            </Typography>{" "}
          </div>
          <Typography className="users-table-generic-label">
            <img src={AddressIcon} /> 100 Twinge Lane apt #290, New York, NY
            10001
          </Typography>
        </Col>
        <Col
          className="mb-10 mt-10"
          lg={6}
          xl={6}
          xxl={6}
          md={12}
          sm={24}
          xs={24}
        >
          {latesOrder && (
            <>
              <Typography className="users-table-generic-label">
                DOB:{latesOrder.demoGraphics.dob}
              </Typography>
              <Typography className="users-table-generic-label">
                {latesOrder.demoGraphics.weight} lb,{" "}
                {latesOrder.demoGraphics.heightFeet}’{" "}
                {latesOrder.demoGraphics.heightInches}”
              </Typography>
              {latesOrder.demoGraphics.gender.toUpperCase()}{" "}
              {latesOrder.demoGraphics.pregnant && <strong> - Pregnant</strong>}
            </>
          )}
        </Col>
        <Col
          className="mb-10 mt-10"
          lg={8}
          xl={8}
          xxl={8}
          md={12}
          sm={24}
          xs={24}
        >
          <Typography className="users-table-generic-label">
            Joined {formatDateInMMDDYYYY(new Date(userProfile.createdAt))}
          </Typography>
          <Typography className="users-table-generic-label">
            Last order on{" "}
            {latesOrder
              ? formatDateInMMDDYYYY(new Date(latesOrder.createdAt))
              : "---"}
          </Typography>
        </Col>
      </Row>
      <Row className="mt-30 w-100p">
        <Col span={24}>
          <Typography className="user-profile-allergies-title">
            Allergies:{" "}
          </Typography>
        </Col>

        <Col span={24}>
          {latesOrder &&
            latesOrder.demoGraphics.allAllergies.map((item, index) => {
              return (
                <span
                  key={Math.random()}
                  className="user-profile-allergy-label"
                >
                  {item.type} - {item.severity},
                </span>
              );
            })}
        </Col>
      </Row>
      <Row className="mt-20 mb-10 w-100p">
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
            marginTop: "10px",
          }}
          span={24}
        >
          <Button type="primary">Bulk Action</Button>
        </Col>
      </Row>
      <Row className="w-100p ">
        <Col span={24}>
          <Typography className="dashboard-page-sub-title">
            Order History
          </Typography>
        </Col>

        {isShowTableInDesktop === true ? (
          <>
            <Row className="table-container w-100p mt-20">
              <TableHeader
                headOptions={desktopTableHeaders}
                handleCheckBox={handleCheckBox}
              />
            </Row>
            {orderHistory.map((item, index) => {
              return (
                <OrderHistoryTableRow
                  key={`user-order-history-item-container-desktop-${index}`}
                  activeBg={index % 2 === 0 ? "#F9F9F9" : "#FFFFFF"}
                  order={item}
                />
              );
            })}
          </>
        ) : (
          <>
            <Row className="w-100p mt-20" gutter={[16, 16]}>
              {}
              {orderHistory.map((item, index) => {
                return (
                  <Col
                    key={`user-order-history-item-container-mobile-col-${index}`}
                    lg={12}
                    md={12}
                    xl={12}
                    xxl={12}
                    sm={24}
                    xs={24}
                  >
                    <OrderHistoryCard
                      key={`user-order-history-item-container-mobile-${index}`}
                      order={item}
                    />
                  </Col>
                );
              })}
              {/* <Col lg={12} md={12} xl={12} xxl={12} sm={24} xs={24}>
                <OrderHistoryCard />
              </Col>
              <Col lg={12} md={12} xl={12} xxl={12} sm={24} xs={24}>
                <OrderHistoryCard />
              </Col>
              <Col lg={12} md={12} xl={12} xxl={12} sm={24} xs={24}>
                <OrderHistoryCard />
              </Col> */}
            </Row>
          </>
        )}
      </Row>
    </>
  );
}
